import React from 'react'
import { AuthChecker } from '../../Components/Views/AuthChecker'
import { LogoView } from '../../Components/Views/LogoView'
import { controllers } from '../../Controllers/Controllers'
import { MenuController } from '../../Controllers/MenuController'
import { navigator } from '../../Controllers/Navigator'
import { UpdateComponent } from '../../Components/Views/UpdateComponent'
import { UPDATE } from '../../DataTypes/UPDATE'
import './smart-menu.css'
import { Link } from 'react-router-dom'
import { NotificationBell } from '../UIComponents/NotificationBell'

class MenuView extends UpdateComponent {
    dropdownRef: any;
    state: any;
    props:any;

    constructor(props: any) {
        super(props)
        this.state = {
            userDropdownOpen: false
        }
        this.dropdownRef = React.createRef()
        this.type = UPDATE.USERINFO
    }

    get controller(): MenuController {
        return this.props.controller
    }

    componentDidMount() {
        super.componentDidMount()
        document.addEventListener('click', this.handleClickOutside)
        document.addEventListener('keydown', this.handleKeyDown)
    }

    componentWillUnmount() {
        super.componentWillUnmount()
        document.removeEventListener('click', this.handleClickOutside)
        document.removeEventListener('keydown', this.handleKeyDown)
    }

    handleClickOutside = (event: any) => {
        if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
            this.setState({ userDropdownOpen: false })
        }
    }

    handleKeyDown = (event: any) => {
        if (event.key === 'Escape') {
            this.setState({ userDropdownOpen: false })
        }
    }

    openAuth = () => {
        controllers().auth.setAfterAuth("")
        controllers().modals.authModal.show()
    }

    toggleUserDropdown = () => {
        this.setState((prev: any) => ({ userDropdownOpen: !prev.userDropdownOpen }))
    }

    handleSignOut = () => {
        controllers().auth.signOut()
        this.setState({ userDropdownOpen: false })
    }

    getUserInitials = () => {
        const user = controllers().auth.userInfo
        if (user && user.first_name) {
            return (user.first_name+" "+user.last_name).split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
        }
        if(user?.email){
            return user.email[0].toUpperCase()
        }
        return 'U'
    }

    render() {
        const { blured } = this.controller
        const profilePicture = controllers().auth.userInfo?.profile_picture
        return (
            <>
                <div className="smart-menu-wrapper">
                    <div className={`smart-menu-container ${blured ? 'menu-header-blurred' : ''}`}>
                        <div className="menu-header-logo-section">
                            <LogoView />
                        </div>

                        <div className="smart-menu-right">
                            <AuthChecker isLogined={false}>
                                <button
                                    className="smart-menu-btn smart-menu-btn-primary"
                                    onClick={this.openAuth}
                                >
                                    Sign in
                                </button>
                            </AuthChecker>

                            <AuthChecker isLogined={true}>
                                <div className='rms-container'>
                                    <NotificationBell/>
                                    <div className="smart-menu-avatar-wrap" ref={this.dropdownRef}>
                                        <div
                                            className="smart-menu-avatar"
                                            onClick={this.toggleUserDropdown}
                                            role="button"
                                            tabIndex={0}
                                            onKeyDown={(e) => e.key === 'Enter' && this.toggleUserDropdown()}
                                        >
                                            {profilePicture ? (
                                                <img src={profilePicture} alt="avatar" />
                                            ) : (
                                                this.getUserInitials()
                                            )}
                                        </div>

                                        <div className={`smart-menu-dropdown smart-menu-dropdown-right ${this.state.userDropdownOpen ? 'smart-menu-dropdown-open' : ''}`}>
                                            <Link to="/settings" onClick={navigator().afterLocateFunctions} className="smart-menu-dropdown-item">Settings</Link>
                                            <button className="smart-menu-dropdown-item smart-menu-dropdown-danger" onClick={this.handleSignOut}>Sign Out</button>
                                        </div>
                                    </div>
                                </div>
                            </AuthChecker>
                        </div>
                    </div>
                </div>
                <div className="smart-menu-spacer" />
            </>
        )
    }
}

export { MenuView }
